/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/

/**
 * Include this file first whenever adding aria javascript to a page
 * Then include the specific file for the type of feature, e.g. aria.dialog.js for dialog/modal windows
 * 
 * @namespace aria
 */

 var aria = aria || {};

 /**
  * @desc
  *  Key code constants
  */
 aria.KeyCode = {
   BACKSPACE: 8,
   TAB: 9,
   RETURN: 13,
   ESC: 27,
   SPACE: 32,
   PAGE_UP: 33,
   PAGE_DOWN: 34,
   END: 35,
   HOME: 36,
   LEFT: 37,
   UP: 38,
   RIGHT: 39,
   DOWN: 40,
   DELETE: 46
 };
     
 aria.Utils = aria.Utils || {};
 
 // Polyfill src https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 aria.Utils.matches = function (element, selector) {
   if (!Element.prototype.matches) {
     Element.prototype.matches =
       Element.prototype.matchesSelector ||
       Element.prototype.mozMatchesSelector ||
       Element.prototype.msMatchesSelector ||
       Element.prototype.oMatchesSelector ||
       Element.prototype.webkitMatchesSelector ||
       function (s) {
         var matches = element.parentNode.querySelectorAll(s);
         var i = matches.length;
         while (--i >= 0 && matches.item(i) !== this) {}
         return i > -1;
       };
   }
 
   return element.matches(selector);
 };
 
 aria.Utils.remove = function (item) {
   if (item.remove && typeof item.remove === 'function') {
     return item.remove();
   }
   if (item.parentNode &&
       item.parentNode.removeChild &&
       typeof item.parentNode.removeChild === 'function') {
     return item.parentNode.removeChild(item);
   }
   return false;
 };
 
 aria.Utils.isFocusable = function (element) {
   if (element.disabled) {
     return false;
   }
 
   if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) || element.tabIndex == -1) {
     return true;
   }
 
   switch (element.nodeName) {
     case 'A':
       return !!element.href && element.rel != 'ignore';
     case 'INPUT':
       return element.type != 'hidden' && element.type != 'file';
     case 'BUTTON':
     case 'SELECT':
     case 'TEXTAREA':
       return true;
     default:
       return false;
   }
 };
     
   aria.Utils.getAncestorBySelector = function (element, selector) {
     if (!aria.Utils.matches(element, selector + ' ' + element.tagName)) {
       // Element is not inside an element that matches selector
       return null;
     }
   
     // Move up the DOM tree until a parent matching the selector is found
     var currentNode = element;
     var ancestor = null;
     while (ancestor === null) {
       if (aria.Utils.matches(currentNode.parentNode, selector)) {
         ancestor = currentNode.parentNode;
       }
       else {
         currentNode = currentNode.parentNode;
       }
     }
   
     return ancestor;
   };
   
   aria.Utils.hasClass = function (element, className) {
     return (new RegExp('(\\s|^)' + className + '(\\s|$)')).test(element.className);
   };
   
   aria.Utils.addClass = function (element, className) {
     if (!aria.Utils.hasClass(element, className)) {
       element.className += ' ' + className;
     }
   };
   
   aria.Utils.removeClass = function (element, className) {
     var classRegex = new RegExp('(\\s|^)' + className + '(\\s|$)');
     element.className = element.className.replace(classRegex, ' ').trim();
   };
   
   aria.Utils.bindMethods = function (object /* , ...methodNames */) {
     var methodNames = Array.prototype.slice.call(arguments, 1);
     methodNames.forEach(function (method) {
       object[method] = object[method].bind(object);
     });
   };
 
 /**
  * @desc Set focus on descendant nodes until the first focusable element is
  *       found.
  * @param element
  *          DOM node for which to find the first focusable descendant.
  * @returns
  *  true if a focusable element is found and focus is set.
  */
 aria.Utils.focusFirstDescendant = function (element) {
   for (var i = 0; i < element.childNodes.length; i++) {
     var child = element.childNodes[i];
     if (aria.Utils.attemptFocus(child) ||
         aria.Utils.focusFirstDescendant(child)) {
       return true;
     }
   }
   return false;
 }; // end focusFirstDescendant
 
 /**
  * @desc Find the last descendant node that is focusable.
  * @param element
  *          DOM node for which to find the last focusable descendant.
  * @returns
  *  true if a focusable element is found and focus is set.
  */
 aria.Utils.focusLastDescendant = function (element) {
   for (var i = element.childNodes.length - 1; i >= 0; i--) {
     var child = element.childNodes[i];
     if (aria.Utils.attemptFocus(child) ||
         aria.Utils.focusLastDescendant(child)) {
       return true;
     }
   }
   return false;
 }; // end focusLastDescendant
 
 /**
  * @desc Set Attempt to set focus on the current node.
  * @param element
  *          The node to attempt to focus on.
  * @returns
  *  true if element is focused.
  */
 aria.Utils.attemptFocus = function (element) {
   if (!aria.Utils.isFocusable(element)) {
     return false;
   }
 
   aria.Utils.IgnoreUtilFocusChanges = true;
   try {
     element.focus();
   }
   catch (e) {
   }
   aria.Utils.IgnoreUtilFocusChanges = false;
   return (document.activeElement === element);
 }; // end attemptFocus
 /* end aria.utils.js file */